const adjustmentJobResponseToAdjustmentJobObject = (response) => {
    return {
        id: response.id,
        createdAt: response.created_at,
        userId: response.user_id,
        integrationId: response.integration_id,
        jobExecutionId: response.job_execution_id,
        adjustmentProcessingStatus: response.adjustment_processing_status,
    };
};

export { adjustmentJobResponseToAdjustmentJobObject };
